<template>
  <div class="builderModalSkeleton" data-test="skeleton">
    <div class="builderModalSkeleton_image" data-drag-zone>
      <builder-modal-close v-if="showClose" data-test="close" @click="$emit('close')" />
    </div>
    <div class="builderModalSkeleton_body">
      <div class="builderModalSkeleton_bar -heading" />
      <div class="builderModalSkeleton_bar -heading -short" />
      <div class="builderModalSkeleton_bar" />
      <div class="builderModalSkeleton_bar" />
      <div class="builderModalSkeleton_bar -short" />
      <div class="builderModalSkeleton_buttons">
        <div class="builderModalSkeleton_button -primary" />
        <div class="builderModalSkeleton_button" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import BuilderModalClose from './BuilderModalClose.vue'

// Один на все модалки: всегда две кнопки-заглушки, «×» активен уже здесь.
defineProps({
  showClose: { type: Boolean, default: true }
})
defineEmits(['close'])
</script>

<style lang="scss" scoped>
@import './builderModal';

.builderModalSkeleton {
  &_image {
    position: relative;
    height: $bm-desktop-image-height;
    background: linear-gradient(180deg, rgba(var(--ac-color-rgb-deep-liliac), .35) 0%, var(--ac-color-white) 100%);

    @media (max-width: $screen-desktop) {
      height: auto;
      aspect-ratio: $bm-sheet-image-ratio;
    }
  }

  &_body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: $bm-skeleton-bar-gap;
    padding: 0 $bm-content-padding $bm-bottom-padding;
  }

  &_bar {
    width: 100%;
    height: $bm-skeleton-bar-height;
    border-radius: $bm-skeleton-radius;
    background: var(--ac-color-light-gray);

    &.-heading {
      height: $bm-skeleton-heading-height;
    }

    &.-short {
      width: 60%;
    }
  }

  &_buttons {
    display: flex;
    flex-direction: column;
    gap: $bm-button-gap;
    width: 100%;
    margin-top: $bm-gap-buttons;
  }

  &_button {
    height: $bm-button-height;
    border-radius: $bm-button-radius;
    background: var(--ac-color-light-gray);

    &.-primary {
      background: var(--ac-color-deep-liliac);
    }
  }
}
</style>
